RivalIQ.apps.Admin.module('collections', function (collections, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    collections.Invoices = Backbone.Collection.extend({

        model: App.models.Invoice,

        initialize: function (data) {
            const me = this;
            me.url = `/admin/api/accounts/${data.account_id}/invoices`;
        },

        comparator: function (model) {
            return -1 * moment.utc(model.get('invoice_period_start')).valueOf();
        }

    });

}, window.moment);
